import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { SharedService } from '../../../layouts/shared-service';
import { FboairportsService } from '../../../services/fboairports.service';
// Services
import { FbosService } from '../../../services/fbos.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { localStorageAccessConstant } from 'src/app/constants/LocalStorageAccessConstant';

@Component({
    selector: 'app-fbos-home',
    styleUrls: ['./fbos-home.component.scss'],
    templateUrl: './fbos-home.component.html',
})
export class FbosHomeComponent implements OnInit {
    @Input() groupInfo: any;
    @Input() embed: boolean;

    // Public Members
    public fbosData: Array<any>;
    public currentFbo: any;
    public currentFboAirport: any;
    public chartName = 'FBOs';

    constructor(
        private router: Router,
        private fboService: FbosService,
        private fboAirportsService: FboairportsService,
        private sharedService: SharedService,
        private ngxLoader: NgxUiLoaderService
    ) {
        this.currentFbo = null;
        this.currentFboAirport = null;
    }

    async ngOnInit() {
        this.ngxLoader.startLoader(this.chartName);
        this.fbosData =  await this.loadAllFbosForGroup();
        this.ngxLoader.stopLoader(this.chartName);
    }

    public editFboClicked(record) {
        if (!this.groupInfo) {
            this.router.navigate(['/default-layout/fbos/' + record.oid]);
        } else {
            this.ngxLoader.startLoader(this.chartName);

            this.fboService
                .get(record)
                .subscribe((data: any) => { this.currentFbo = data; this.ngxLoader.stopLoader(this.chartName); });
            this.fboAirportsService
                .getForFbo(record)
                .subscribe((data: any) => { this.currentFboAirport = data; this.ngxLoader.stopLoader(this.chartName); });
        }
    }

    public async saveFboEditClicked() {
        this.currentFboAirport = null;
        this.currentFbo = null;
        this.fbosData = null;
        this.fbosData =  await this.loadAllFbosForGroup(); 
    }

    public cancelFboEditClicked() {
        this.currentFbo = null;
    }

    // Private Methods
    private async loadAllFbosForGroup() :Promise<any> {
        let groupId: number = (!this.groupInfo) ? this.sharedService.getCurrentUserPropertyValue<number>(localStorageAccessConstant.groupId) : this.groupInfo.oid;
        return this.fboService.getForGroup(groupId).toPromise();
    } 
}
